module.exports = __webpack_public_path__ + "img/Батыс Қазақстан облысы.2cbd2a00.png";